/**
 * @author mkunze
 *
 * Use this to handle Data in Tables etc.
 */
/** @deprecated since v5.0. Please use an object or ck-editor instead **/
export class TerraBaseData {}
